(function () {
  function getMobileSwiper() {
    var selectors = [
      '.sf-product-media__mobile .swiper-container',
      '.sf-product-media__mobile .swiper',
      '.nav-swiper-container-mobile .swiper-container'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.swiper) return el.swiper;
    }
    return null;
  }
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || !variant.featured_media) return;
    var swiper = getMobileSwiper();
    if (!swiper) return;
    swiper.slideToLoop(variant.featured_media.position - 1, 300);
  });
})();
